import { createConsoleLogger } from './baseLogger';
export let logger = createConsoleLogger();
export function setLogger(newLogger) {
    logger = newLogger;
}
export const flags = {};
export function setFlags(newFlags) {
    Object.assign(flags, newFlags);
}
//# sourceMappingURL=logger.js.map